export const signinAppPath = '/signin';
export const forgotPasswordPath = '/forgot-password';
export const changePasswordPath = '/change-password';

export default {
  signinAppPath,
  forgotPasswordPath,
  changePasswordPath,
};
